import { pick, serverMap } from '@/shared/lib/server-map'
import type { Notification } from '@/shared/api'

/**
 * `Notification.kind` → цвет точки. Контракт задаёт только смысл поля («определяет цвет точки
 * на фронте», `openapi/components/schemas/notification.yaml`), не сами значения — сопоставление
 * ниже подобрано по образцу макета (prototype/Prototype.dc.html:188,193,198), где видно 3 из
 * 4 kind на реальных примерах:
 *   - pending («ждут подтверждения») → `--st-pending` — цвет точки в макете совпадает буквально;
 *   - warning («возможные дубли») → `--st-cancel` — в макете тоже совпадает буквально;
 *   - success («синхронизация возобновлена») → `--st-in` — совпадает буквально.
 * `info` в макете примера не имеет (в статичной выборке из трёх карточек его нет) — выбран
 * `--st-confirmed` (синий): так все четыре значения `kind` получают свой статусный токен без
 * пересечений, тем же набором, что и статусы брони. Незнакомый `kind` (контракт расширят
 * раньше фронта) тихо уезжает в нейтральный `--ink-4`, а не роняет попап — через общую дверь
 * `pick` (`shared/lib/server-map.ts`).
 */
const KIND_TOKENS = serverMap({
  pending: 'var(--st-pending)',
  warning: 'var(--st-cancel)',
  success: 'var(--st-in)',
  info: 'var(--st-confirmed)',
})

const FALLBACK = 'var(--ink-4)'

export function notificationColor(notification: Pick<Notification, 'kind'>): string {
  return pick(KIND_TOKENS, notification.kind, FALLBACK)
}
